"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingMessage = function LoadingMessage(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.NoOptionsMessage, props, /*#__PURE__*/_react["default"].createElement("span", null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0433\u043E\u0440\u043E\u0434\u043E\u0432..."));
};

exports.LoadingMessage = LoadingMessage;